export enum CapabilityViewType {
  BANKING = 'BANKING',

  KEY_HOLDER = 'KEY_HOLDER',

  FURNITURE_CHANGEOVER = 'FURNITURE_CHANGEOVER',

  SALESPERSON = 'SALESPERSON',

  SHOP_OPENER = 'SHOP_OPENER',

  SHOP_CLOSER = 'SHOP_CLOSER',

  CHANGEOVER_MANAGER = 'CHANGEOVER_MANAGER'
}
